import React from 'react';

import { ToolCard } from './index';
import type { ToolsToolTip } from './types';
import type { ErgonomicTools } from '@/hooks';
import type { Tool } from '@/components/ApplyTool';

const TITLE_MAP = {
	'kim-lhc': 'Lifting and transportation'
};

const SUBTITLE_MAP = {
	'kim-lhc': '(KIM LHC)',
	niosh: '(NIOSH/ISO 11228-1)'
};

export interface ToolCardItemProps {
	fileId: string;
	tool: ErgonomicTools;
	isActive: boolean;
	toolsTooltip?: ToolsToolTip;
}

function getTitle(tool: ErgonomicTools): string {
	const title = TITLE_MAP[tool.description as unknown as keyof typeof TITLE_MAP];

	return title ?? tool.title;
}

function getSubtitle(tool: ErgonomicTools): string {
	const subtitle = SUBTITLE_MAP[tool.description as unknown as keyof typeof SUBTITLE_MAP];

	return subtitle ?? tool.subtitle;
}

export function ToolCardItem({ fileId, tool, isActive, toolsTooltip }: Readonly<ToolCardItemProps>): JSX.Element {
	return (
		<ToolCard
			fullWidth
			showTitle={false}
			fileId={fileId}
			title={getTitle(tool)}
			subTitle={getSubtitle(tool)}
			type={tool.description as Tool}
			isActive={isActive}
			reportSelected={tool.description}
			toolTip={toolsTooltip?.[tool.description]?.tooltip}
			toolTipPosition={toolsTooltip?.[tool.description]?.tooltip_position}
		/>
	);
}
